import React from 'react'
import { NoWrapText } from 'style'

export const formatManualCommunicationProgress = (expectedUsersCount: number | null, actualUsersCount: number | null) => {
    if (!expectedUsersCount || !actualUsersCount) return `n/a`

    return <NoWrapText>{`${actualUsersCount} / ${expectedUsersCount}`}</NoWrapText>
}
